// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"1b6e6349","256":"2f40dc3a","453":"611b359d"}[chunkId] + ".chunk.js";
};